import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './Shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { UserSettingComponent } from './user-setting/user-setting.component';
import { ValidationInterceptor } from './validation.interceptor';
import { ApiUrlRewriteInterceptor } from './api-url-rewrite.interceptor';
import { UnsubscribeEmailComponent } from './unsubscribe-email/unsubscribe-email.component';
import { PrintFormComponent } from './print-form/print-form.component';
import { SubscriptionExpiredComponent } from './subscription-expired/subscription-expired.component';
import { NotificationModule } from './notification/notification.module';
import { GlobalErrorHandler } from './Shared/error-handler/global-error-handler';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CrmCustomPage1Component } from './CRM/crm-custom-page1/crm-custom-page1.component';
import { CrmCustomPage2Component } from './CRM/crm-custom-page2/crm-custom-page2.component';
import { CrmCustomPage3Component } from './CRM/crm-custom-page3/crm-custom-page3.component';
import { CrmCustomPage4Component } from './CRM/crm-custom-page4/crm-custom-page4.component';
import { CrmCustomPage5Component } from './CRM/crm-custom-page5/crm-custom-page5.component';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    UserSettingComponent,
    UnsubscribeEmailComponent,
    PrintFormComponent,
    SubscriptionExpiredComponent,
    CrmCustomPage1Component,
    CrmCustomPage2Component,
    CrmCustomPage3Component,
    CrmCustomPage4Component,
    CrmCustomPage5Component,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NotificationModule,
    ServiceWorkerModule.register(environment.firebaseJs, {
      // Was `!isDevMode()` (service worker disabled during `ng serve`/`npm start`,
      // since Angular doesn't optimize those builds). Forced on unconditionally
      // so Push Notifications (which need this service worker) can be tested
      // with the normal `npm start` workflow — firebase-messaging-sw.js has no fetch handler,
      // so it doesn't cache/intercept anything and won't interfere with live
      // reload. If firebase-messaging-sw.js ever grows a fetch handler, revisit this.
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
    
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ValidationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiUrlRewriteInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
